module.exports = __webpack_public_path__ + "img/vertical_4_5_8019.7f92cf0b.png";